var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { usePumpFamilySelection } from "hooks/use-pump-family-selection";
import { getPumpFullName } from "utility/pump-families";
/* Options for selecting the pump of one or more central vacuum pump nodes,
 * shared by the pump overlay in the canvas and the sidebar menu. */
export var useCentralPumpOptions = function (nodeIds) {
    var _a;
    var dispatch = useAppDispatch();
    var t = useTranslation().t;
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var selectedPumps = useAppSelector(selectors.selectSelectedCentralPumps(nodeIds));
    var selectedPumpValues = useMemo(function () { return selectedPumps.map(function (pump) { return pump === null || pump === void 0 ? void 0 : pump.value; }); }, [selectedPumps]);
    var pumpOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.vacuumPumpComponents))
            return [];
        return Object.values(systemDataDefineParameters.vacuumPumpComponents).filter(function (component) {
            return component.valid || selectedPumpValues.includes(component.value);
        });
    }, [selectedPumpValues, systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.vacuumPumpComponents]);
    var selectedPumpOptions = useMemo(function () {
        return selectedPumps.filter(function (pump) { return pump !== undefined; });
    }, [selectedPumps]);
    var commitPump = useCallback(function (pump) {
        return dispatch(actions.selectCentralPump({ nodeIds: nodeIds, value: pump }));
    }, [dispatch, nodeIds]);
    var familySelection = usePumpFamilySelection(pumpOptions, selectedPumpOptions, commitPump, nodeIds);
    var selectedValues = useMemo(function () { return selectedPumpOptions.map(function (pump) { return pump.value; }); }, [selectedPumpOptions]);
    /* Multiple nodes can be selected at once; we label by the first of them
     * that has a pump committed to Tacton. */
    var selectedLabel = selectedPumpOptions[0] &&
        getPumpFullName(selectedPumpOptions[0], t("sidebar.edit_pump.no_features"));
    var selectedImage = (_a = selectedPumpOptions[0]) === null || _a === void 0 ? void 0 : _a.image;
    return __assign(__assign({}, familySelection), { pumpOptions: pumpOptions, selectedValues: selectedValues, selectedLabel: selectedLabel, selectedImage: selectedImage });
};
